module.exports = __webpack_public_path__ + "media/images/pages/get-involved/amy-12b8e85a220756c4fa3f2bce1e0f6f90.png";